import { render, staticRenderFns } from "./05_OwnersDataForm.vue?vue&type=template&id=de08b384&"
import script from "./05_OwnersDataForm.vue?vue&type=script&lang=js&"
export * from "./05_OwnersDataForm.vue?vue&type=script&lang=js&"
import style0 from "./05_OwnersDataForm.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports